import { render, staticRenderFns } from "./offsetLogisReceipt.vue?vue&type=template&id=2410eb2c&scoped=true&"
import script from "./offsetLogisReceipt.vue?vue&type=script&lang=js&"
export * from "./offsetLogisReceipt.vue?vue&type=script&lang=js&"
import style0 from "./offsetLogisReceipt.vue?vue&type=style&index=0&id=2410eb2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2410eb2c",
  null
  
)

component.options.__file = "offsetLogisReceipt.vue"
export default component.exports